import { store } from '../store';
import { actualizarCuestionario } from '../../apiService/request/CrudSeguimiento';

export default {
  data() {
    return {
      variablesObligatorias: [],
    };
  },
  computed: {
    getVariablesFormularios() {
      if (this.$store.getters.getVariablesFormularios != null) {
        this.variablesObligatorias = this.$store.getters.getVariablesFormularios.filter(variable => variable.obligatorio === true);
        this.variablesObligatorias = this.variablesObligatorias.map(variable => (variable.variable));
      }
      return this.$store.getters.getVariablesFormularios;
    },
  },
  watch: {
    getVariablesFormularios() {},
  },
  methods: {
    filtroVariablesObligatoriasDiligenciadas(key) {
      const variablesActualizadas = this.$store.getters.getVariablesActualizadas;
      const variablesDiligenciadas = this.variablesObligatorias.map(z => variablesActualizadas.filter(c => c.nombre == z));
      this.filtroVariablesObligatoriasSinDiligenciar(variablesDiligenciadas, key);
    },
    filtroVariablesObligatoriasSinDiligenciar(variablesDiligenciadas, key) {
      variablesDiligenciadas = variablesDiligenciadas.filter(c => c.length > 0);
      variablesDiligenciadas = variablesDiligenciadas.map(c => c[0].nombre);
      const variablesObligatoriasSinDiligenciar = this.variablesObligatorias.filter(x => variablesDiligenciadas.indexOf(x) < 0);
      this.validacionActualizarFormulario(variablesObligatoriasSinDiligenciar, key);
    },
    validacionActualizarFormulario(variablesObligatoriasSinDiligenciar, key) {
      if (variablesObligatoriasSinDiligenciar.length === 0) {
        this.actualizarFormularioActual();
      } else {
        const respuesta = {
          data: {
            message:
              `Los siguientes campos son obligatorios: ${
                variablesObligatoriasSinDiligenciar}`,
          },
          status: 400,
        };
        this.$store.dispatch('cambiarEstadoModal', true);
        this.$store.dispatch('cambiarMensajeModal', respuesta);
      }
    },
    // eslint-disable-next-line space-before-blocks
    async actualizarFormularioActual(key){
      try {
        const respuesta = await actualizarCuestionario(this.$store.getters.getIdFormulario, this.$store.getters.getVariablesActualizadas, this.$store.getters.getNombreFormulario, 'formularios', this.$store.state.provider_email);
        store.dispatch('setVariablesActualizadas', []);
        store.dispatch('setIdFormulario', null);
        this.$store.dispatch('cambiarEstadoModal', true);
        this.$store.dispatch('cambiarMensajeModal', respuesta);
	      this.consultarListaCuestionarioGeneral();
        this.preguntasEncuestas = [];
        setTimeout(() => {
          store.dispatch('setVariablesFormularios', []);
          store.dispatch('setVariablesActualizadas', []);
        }, 1500);
      } catch (err) {

      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/js/mixins/mixinActualizarValidarVariables.js